import { useCallback, useState } from 'react';
import { PreviewAdminChangelogEditionAPI } from '../../../../api/AdminAPI';

const CLOSED_PREVIEW = { open: false, loading: false, error: null, subject: '', html: '' };

/**
 * useEditionPreview
 *
 * Prévia do e-mail de um envio (iframe) e envio da prévia a um e-mail digitado na hora.
 *
 * @param {Function} notify - (message, severity) mostra o aviso da tela
 */
function useEditionPreview(notify) {
  const [preview, setPreview] = useState(CLOSED_PREVIEW);
  const [isSendingPreview, setIsSendingPreview] = useState(false);

  const openPreview = useCallback((edition) => {
    setPreview({ ...CLOSED_PREVIEW, open: true, loading: true, subject: edition.subject || '' });
    PreviewAdminChangelogEditionAPI(edition.id, false, (response) => {
      if (!response || response.success === false) {
        setPreview((prev) => ({ ...prev, loading: false, error: response?.error || 'Não foi possível montar a prévia.' }));
        return;
      }
      setPreview((prev) => ({ ...prev, loading: false, subject: response.subject || prev.subject, html: response.html || '' }));
    });
  }, []);

  const closePreview = useCallback(() => setPreview(CLOSED_PREVIEW), []);

  const sendPreview = useCallback((edition, to) => {
    setIsSendingPreview(true);
    PreviewAdminChangelogEditionAPI(edition.id, true, (response) => {
      setIsSendingPreview(false);
      if (!response || response.success === false) {
        notify(response?.error || 'Não foi possível enviar a prévia.', 'error');
        return;
      }
      notify(`Prévia enviada para ${response.sent_to || to}.`, 'success');
    }, to);
  }, [notify]);

  return { preview, openPreview, closePreview, sendPreview, isSendingPreview };
}

export default useEditionPreview;
